import { SpecificItem, SpecificItemAction } from "@libs/types/enum";
import { DriverSocketMsg, DriverSocketMsgType } from "@libs/types/message";
import { DriverService } from "./driver";

class SetOrRead {

    async read<T>(item: SpecificItem, value: any | null = null): Promise<T> {
        const data = {
            Type: DriverSocketMsgType.MTSetOrReadSpecificItem,
            Data: { Item: item, Action: SpecificItemAction.Read, Value: value },
        } as DriverSocketMsg<any>
        return DriverService.instance.askTypeAndData<T>(data)
    }
    async write<T>(item: SpecificItem, value: any): Promise<T> {
        const data = {
            Type: DriverSocketMsgType.MTSetOrReadSpecificItem,
            Data: { Item: item, Action: SpecificItemAction.Write, Value: value },
        } as DriverSocketMsg<any>;
        return DriverService.instance.askTypeAndData<T>(data)
    }
}

let setOrRead = new SetOrRead();
export { setOrRead };
